<template>
  <validation-provider
    :mode="vmode"
    :vid="vid"
    :name="name"
    :rules="rules"
    v-slot="{ dirty, validated, valid, errors }"
  >
    <b-form-group
      :id="`input-group-${id}`"
      :label="label"
      :label-for="
        ['username', 'password'].includes(name) ? name : `input-${id}`
      "
      :class="{
        asterisk:
          Object.keys(rules).includes('required') ||
          (Object.keys(rules).includes('required_if') && !valid) ||
          (Object.keys(rules).includes('required_with') && !valid),
        filled: inputVal,
      }"
    >
      <!-- <pre style="background-color: pink">
        inputVal: {{ inputVal }}.<br />
        typeof inputVal: {{ typeof inputVal }}.<br />
        typeof inputVal === 'object': {{ typeof inputVal === 'object' }}.<br />
        Object.keys(inputVal || {})?.length: {{ Object.keys(inputVal || {})?.length }}.<br />
        typeof inputVal === 'string': {{ typeof inputVal === 'string' }}.<br />
        inputVal?.length {{ inputVal?.length }}.<br />
      </pre>
      <pre style="background-color: aquamarine">
        (typeof inputVal === 'object' &&
            !Object.keys(inputVal || {}).length) ||
          ((typeof inputVal === 'string' || typeof inputVal === 'number') &&
            !`${inputVal}`.length): {{ evaluateInputVal }}.<br />
      </pre> -->
      <b-form-input
        :id="`${
          ['username', 'password'].includes(name) ? name : `input-${id}`
        }`"
        :name="`${
          ['username', 'password'].includes(name) ? name : `input-${id}`
        }`"
        :type="type"
        :style="
          type === 'currency' || custom_type === 'currency'
            ? { 'text-align': 'right' }
            : ''
        "
        :maxlength="maxlength"
        v-model="inputVal"
        :state="
          evaluateInputVal
            ? null
            : getValidationState({ dirty, validated, valid, errors })
        "
        :aria-describedby="['username', 'password'].includes(name) ? `${name}-live-feedback` : `input-${id}-live-feedback`"
        :autocomplete="autocomplete"
        :disabled="disabled"
        :placeholder="placeholder"
        @keyup="onKeyUp"
        @blur="onBlur"
        :formatter="formatter"
        :readonly="readonly"
      ></b-form-input>
      <!-- @input="(val) => { if( textcase === 'upper') { inputVal = val.toUpperCase() } }" -->
      <b-form-invalid-feedback :id="['username', 'password'].includes(name) ? `${name}-live-feedback` : `input-${id}-live-feedback`">{{
        errors[0]
      }}</b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>
<script>
export default {
  // type:
  // text, password, email, number, url, tel, search, date, datetime, datetime-local, month, week, time, range, color
  props: {
    autocomplete: {
      type: String,
      default: "on",
    },
    readonly: {
      value: Boolean,
      default: false,
    },
    value: null,
    vid: String,
    name: String,
    label: String,
    placeholder: String,
    maxlength: {
      default: "50",
      type: String,
    },
    custom_type: {
      default: "text",
      type: String,
    },
    type: {
      default: "text",
      type: String,
    },
    textcase: {
      default: "normal",
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default() {
        return {};
      },
    },
    vmode: {
      type: String,
      default: "aggressive",
    },
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  computed: {
    evaluateInputVal() {
      /* If inputVal is empty don't perform any validations */
      // console.log("typeof this.inputVal", typeof this.inputVal);
      if (
        this.inputVal === null ||
        (typeof this.inputVal === "object" &&
          !Object.keys(this.inputVal || {}).length) ||
        (["number", "string"].includes(typeof this.inputVal) &&
          !`${this.inputVal}`.length)
      ) {
        return true;
      }
      return false;
    },
    inputVal: {
      get() {
        return this.value ?? null;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null, errors = null }) {
      if (errors[0]) return false;
      // return dirty || validated ? valid : null;
      return !Object.keys(this.rules).length
        ? null
        : dirty || validated
        ? valid
        : null;
    },
    onBlur(e) {
      // console.debug("input onBlur", e);
      this.$emit("blur", e);
    },
    onKeyUp(e) {
      this.$emit("keyup", e);
    },
    formatter(value) {
      let ret = value;
      switch (this.type) {
        case "text":
          if (this.textcase === "upper") {
            ret = value.toUpperCase();
          }
          break;
        case "tel":
          ret = value.replace(/\D/g, ""); // replace all non digits
          break;
        default:
          break;
      }
      return ret;
    },
  },
};
</script>
